import loadable from '@loadable/component';
import Header from '../../Header';
import Footer from '../../Footer';
import styles from './ProductFinderLayout.styles';
import Loader from '../../Loader';
import LanguageSuggestPopup from '../../LanguageSuggestPopup';
import VideoOverlay from '../../VideoOverlay';

export interface ProductFinderLayoutProps {
  children: JSX.Element;
}

const AudioPlayer = loadable(
  () => import(/* webpackChunkName: "audio-player" */ '../../AudioPlayer'),
  {
    fallback: <Loader />,
  }
);

const ProductFinderLayout = ({
  children,
}: ProductFinderLayoutProps): JSX.Element => (
  <div>
    <LanguageSuggestPopup />
    <div css={styles.wrapper}>
      <Header />
      {children}
    </div>
    <Footer />
    <AudioPlayer />
    <VideoOverlay />
  </div>
);

export default ProductFinderLayout;
